import React, { useState } from "react";
import { buildApiUrl, cn } from "../../../lib/utils";

const initials = (name?: string) =>
  (name ?? "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase() || "?";

interface DriverAvatarProps {
  name?: string;
  imageUrl?: string;
  className?: string;
}

const DriverAvatar: React.FC<DriverAvatarProps> = ({
  name,
  imageUrl,
  className,
}) => {
  const [failed, setFailed] = useState(false);
  const src = imageUrl && !failed ? buildApiUrl(imageUrl) : "";

  return src ? (
    <img
      src={src}
      alt={name}
      onError={() => setFailed(true)}
      className={cn("h-9 w-9 shrink-0 rounded-full object-cover", className)}
    />
  ) : (
    <div
      className={cn(
        "flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary/10 text-xs font-semibold text-primary",
        className
      )}
    >
      {initials(name)}
    </div>
  );
};

export default DriverAvatar;
